// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-part {
  background-color: white;
  padding: 24px 36px 25px 36px;
  border-radius: var(--radius-md);
}

.field-margin {
  margin: 0px 5px 0px 5px;
}

.form-title {
  margin-bottom: 24px;
}

.form-item {
  margin: 0px !important;
}

.ant-form-item-label {
  padding: 0px !important;
}

.caledar-size {
  width: 100%;
}

.input-group-size {
  width: 70%;
}

.select-group-size {
  width: 30%;
}

.input-group-width {
  width: 100% !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-color: var(--border-color) !important;
  height: var(--control-height) !important;
}
.group-input .ant-input-number-affix-wrapper.ant-input-number-affix-wrapper-has-feedback.ant-input-number-affix-wrapper-lg.ant-input-number-affix-wrapper-rtl.number-input.css-dev-only-do-not-override-14wwjjs {
  width: 100% !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  border-color: var(--border-color) !important;
  height: var(--control-height) !important;
}

.normal-input .ant-input-number-affix-wrapper.ant-input-number-affix-wrapper-has-feedback.ant-input-number-affix-wrapper-lg.ant-input-number-affix-wrapper-rtl.number-input.css-dev-only-do-not-override-14wwjjs {
  width: 100% !important;
  border-radius: var(--radius-md) !important;
  border-color: var(--border-color) !important;
  height: var(--control-height) !important;
}

.form-item .select-border {
  width: 100% !important;
}

.select-border > .ant-select-selector {
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.ant-input-group-rtl .select-border > .ant-select-selector {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.package-name-rectangle {
  width: 100%;
  margin: 8px 2px 8px 2px;
  padding: 14px 77px 14px 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-md);
  background-color: #f0f3f7;
}

/* ——— New package form (Stitch: New package — create form) ——— */
.pkg-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.pkg-form__body {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-width: 0;
  padding-top: 8px;
}

.pkg-form__grid {
  display: grid;
  gap: 20px;
  width: 100%;
  min-width: 0;
}

.pkg-form__grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.pkg-form__grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.pkg-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.pkg-form__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.pkg-form__req {
  color: #EF4444;
}

.pkg-form__item.ant-form-item {
  margin-bottom: 0 !important;
  line-height: normal !important;
}

.pkg-form .ant-form-item {
  margin-bottom: 0 !important;
}

.pkg-form .ant-form-item-label {
  display: none !important;
  padding: 0 !important;
  height: 0 !important;
  overflow: hidden;
}

.pkg-form .ant-form-item-control-input {
  min-height: 40px !important;
}

.pkg-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

.pkg-form .ant-form-item-feedback-icon {
  display: none !important;
}

.pkg-form .ant-form-item-control,
.pkg-form .ant-form-item-control-input,
.pkg-form .ant-form-item-control-input-content {
  max-width: 100%;
  min-width: 0;
}

.pkg-form .ant-select,
.pkg-form .ant-picker,
.pkg-form .ant-input-number {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
}

.pkg-form .ant-form-item-control-input-content > .ant-input,
.pkg-form .ant-form-item-control-input-content > .ant-input-affix-wrapper,
.pkg-form .ant-picker,
.pkg-form .ant-select-selector,
.pkg-form .ant-input-number {
  box-sizing: border-box !important;
  border-radius: 12px !important;
  border: 1px solid #CBD5E1 !important;
  font-size: 14px !important;
  color: #0F172A !important;
  box-shadow: none !important;
  background: #ffffff !important;
}

.pkg-form .ant-input-number .ant-input,
.pkg-form .ant-picker-input > input {
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  height: auto !important;
  min-height: 0 !important;
}

.pkg-form .ant-form-item-control-input-content > input.ant-input,
.pkg-form .ant-select-single .ant-select-selector,
.pkg-form .ant-picker,
.pkg-form .ant-input-number {
  height: 40px !important;
  min-height: 40px !important;
}

.pkg-form .ant-form-item-control-input-content > input.ant-input {
  padding: 0 14px !important;
}

.pkg-form .ant-input-number {
  display: flex !important;
  align-items: center !important;
  padding: 0 !important;
}

.pkg-form .ant-input-number .ant-input-number-input {
  height: 38px !important;
  padding: 0 14px !important;
  font-size: 14px !important;
  font-weight: 500;
  color: #0F172A;
}

.pkg-form .ant-input-number-handler-wrap {
  display: none;
}

.pkg-form__price {
  position: relative;
}

.pkg-form__price .ant-input-number .ant-input-number-input {
  padding-inline-end: 48px !important;
}

.pkg-form__currency {
  position: absolute;
  inset-inline-end: 14px;
  top: 20px;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  pointer-events: none;
  line-height: 1;
}

.pkg-form textarea.ant-input {
  height: auto !important;
  min-height: 112px !important;
  padding: 14px !important;
  line-height: 1.6 !important;
  resize: none;
  font-weight: 400 !important;
}

.pkg-form .ant-picker {
  width: 100%;
  padding: 0 14px !important;
  display: flex !important;
  align-items: center !important;
}

.pkg-form .ant-picker-input > input {
  font-size: 14px !important;
}

.pkg-form input.ant-input::placeholder,
.pkg-form textarea.ant-input::placeholder,
.pkg-form .ant-picker-input > input::placeholder,
.pkg-form .ant-input-number-input::placeholder,
.pkg-form .ant-select-selection-placeholder {
  color: #94A3B8 !important;
  opacity: 1 !important;
  font-weight: 400 !important;
}

.pkg-form .ant-select-selection-item,
.pkg-form .ant-select-selection-placeholder {
  line-height: 38px !important;
  font-size: 14px !important;
}

.pkg-form .ant-select-single .ant-select-selector {
  display: flex !important;
  align-items: center;
  padding-inline: 14px !important;
}

.pkg-form .ant-select-arrow {
  color: #94A3B8;
}

.pkg-form .ant-form-item-control-input-content > .ant-input:hover,
.pkg-form textarea.ant-input:hover,
.pkg-form .ant-picker:hover,
.pkg-form .ant-input-number:hover,
.pkg-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #94A3B8 !important;
}

.pkg-form .ant-form-item-control-input-content > .ant-input:focus,
.pkg-form textarea.ant-input:focus,
.pkg-form .ant-picker-focused,
.pkg-form .ant-input-number-focused,
.pkg-form .ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.pkg-form .ant-input-number .ant-input:focus,
.pkg-form .ant-picker-input > input:focus {
  border: none !important;
  box-shadow: none !important;
}

.pkg-form__segment.ant-radio-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  margin: 0;
  padding: 4px;
  border: 1px solid #CBD5E1;
  border-radius: 12px;
  background: #F8FAFC;
}

.pkg-form__segment .ant-radio-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0;
  padding: 0 8px;
  border-radius: 8px;
  color: #64748B;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
}

.pkg-form__segment .ant-radio-wrapper-checked {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #0EA5E9;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.pkg-form__segment .ant-radio {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}

.pkg-form__segment .ant-radio + span {
  padding: 0;
}

.pkg-form__segment-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.pkg-form__segment-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: transparent;
  flex-shrink: 0;
}

.pkg-form__segment-dot--on {
  background: #0EA5E9;
}

.pkg-form__enable {
  padding: 16px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: rgba(248, 250, 252, 0.7);
  transition: background 0.12s ease;
}

.pkg-form__enable:hover {
  background: #F8FAFC;
}

.pkg-form__enable .ant-checkbox-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin: 0;
}

.pkg-form__enable .ant-checkbox {
  align-self: flex-start;
  margin-top: 2px;
}

.pkg-form__enable .ant-checkbox-inner {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border-color: #CBD5E1;
}

.pkg-form__enable .ant-checkbox-checked .ant-checkbox-inner {
  background: #0EA5E9;
  border-color: #0EA5E9;
}

.pkg-form__enable-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pkg-form__enable-title {
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.pkg-form__enable-hint {
  font-size: 12px;
  font-weight: 400;
  color: #64748B;
  line-height: 1.4;
}

@media (max-width: 1100px) {
  .pkg-form__grid--4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .pkg-form__grid--2,
  .pkg-form__grid--4 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/packages/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,yCAAyC;EACzC,uCAAuC;EACvC,0CAA0C;EAC1C,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,yCAAyC;EACzC,uCAAuC;EACvC,0CAA0C;EAC1C,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,sCAAsC;EACtC,yCAAyC;AAC3C;AACA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;;;;EAKE,iCAAiC;EACjC,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;;EAIE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;;;;;EAKE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".form-part {\n  background-color: white;\n  padding: 24px 36px 25px 36px;\n  border-radius: var(--radius-md);\n}\n\n.field-margin {\n  margin: 0px 5px 0px 5px;\n}\n\n.form-title {\n  margin-bottom: 24px;\n}\n\n.form-item {\n  margin: 0px !important;\n}\n\n.ant-form-item-label {\n  padding: 0px !important;\n}\n\n.caledar-size {\n  width: 100%;\n}\n\n.input-group-size {\n  width: 70%;\n}\n\n.select-group-size {\n  width: 30%;\n}\n\n.input-group-width {\n  width: 100% !important;\n  border-top-left-radius: 5px !important;\n  border-bottom-left-radius: 5px !important;\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-color: var(--border-color) !important;\n  height: var(--control-height) !important;\n}\n.group-input .ant-input-number-affix-wrapper.ant-input-number-affix-wrapper-has-feedback.ant-input-number-affix-wrapper-lg.ant-input-number-affix-wrapper-rtl.number-input.css-dev-only-do-not-override-14wwjjs {\n  width: 100% !important;\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n  border-top-right-radius: 5px !important;\n  border-bottom-right-radius: 5px !important;\n  border-color: var(--border-color) !important;\n  height: var(--control-height) !important;\n}\n\n.normal-input .ant-input-number-affix-wrapper.ant-input-number-affix-wrapper-has-feedback.ant-input-number-affix-wrapper-lg.ant-input-number-affix-wrapper-rtl.number-input.css-dev-only-do-not-override-14wwjjs {\n  width: 100% !important;\n  border-radius: var(--radius-md) !important;\n  border-color: var(--border-color) !important;\n  height: var(--control-height) !important;\n}\n\n.form-item .select-border {\n  width: 100% !important;\n}\n\n.select-border > .ant-select-selector {\n  border-top-right-radius: 5px !important;\n  border-bottom-right-radius: 5px !important;\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n}\n.ant-input-group-rtl .select-border > .ant-select-selector {\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  border-top-left-radius: 5px !important;\n  border-bottom-left-radius: 5px !important;\n}\n\n.package-name-rectangle {\n  width: 100%;\n  margin: 8px 2px 8px 2px;\n  padding: 14px 77px 14px 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: var(--radius-md);\n  background-color: #f0f3f7;\n}\n\n/* ——— New package form (Stitch: New package — create form) ——— */\n.pkg-form {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.pkg-form__body {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  min-width: 0;\n  padding-top: 8px;\n}\n\n.pkg-form__grid {\n  display: grid;\n  gap: 20px;\n  width: 100%;\n  min-width: 0;\n}\n\n.pkg-form__grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.pkg-form__grid--4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.pkg-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.pkg-form__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.pkg-form__req {\n  color: #EF4444;\n}\n\n.pkg-form__item.ant-form-item {\n  margin-bottom: 0 !important;\n  line-height: normal !important;\n}\n\n.pkg-form .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.pkg-form .ant-form-item-label {\n  display: none !important;\n  padding: 0 !important;\n  height: 0 !important;\n  overflow: hidden;\n}\n\n.pkg-form .ant-form-item-control-input {\n  min-height: 40px !important;\n}\n\n.pkg-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.pkg-form .ant-form-item-feedback-icon {\n  display: none !important;\n}\n\n.pkg-form .ant-form-item-control,\n.pkg-form .ant-form-item-control-input,\n.pkg-form .ant-form-item-control-input-content {\n  max-width: 100%;\n  min-width: 0;\n}\n\n.pkg-form .ant-select,\n.pkg-form .ant-picker,\n.pkg-form .ant-input-number {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n}\n\n.pkg-form .ant-form-item-control-input-content > .ant-input,\n.pkg-form .ant-form-item-control-input-content > .ant-input-affix-wrapper,\n.pkg-form .ant-picker,\n.pkg-form .ant-select-selector,\n.pkg-form .ant-input-number {\n  box-sizing: border-box !important;\n  border-radius: 12px !important;\n  border: 1px solid #CBD5E1 !important;\n  font-size: 14px !important;\n  color: #0F172A !important;\n  box-shadow: none !important;\n  background: #ffffff !important;\n}\n\n.pkg-form .ant-input-number .ant-input,\n.pkg-form .ant-picker-input > input {\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  height: auto !important;\n  min-height: 0 !important;\n}\n\n.pkg-form .ant-form-item-control-input-content > input.ant-input,\n.pkg-form .ant-select-single .ant-select-selector,\n.pkg-form .ant-picker,\n.pkg-form .ant-input-number {\n  height: 40px !important;\n  min-height: 40px !important;\n}\n\n.pkg-form .ant-form-item-control-input-content > input.ant-input {\n  padding: 0 14px !important;\n}\n\n.pkg-form .ant-input-number {\n  display: flex !important;\n  align-items: center !important;\n  padding: 0 !important;\n}\n\n.pkg-form .ant-input-number .ant-input-number-input {\n  height: 38px !important;\n  padding: 0 14px !important;\n  font-size: 14px !important;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.pkg-form .ant-input-number-handler-wrap {\n  display: none;\n}\n\n.pkg-form__price {\n  position: relative;\n}\n\n.pkg-form__price .ant-input-number .ant-input-number-input {\n  padding-inline-end: 48px !important;\n}\n\n.pkg-form__currency {\n  position: absolute;\n  inset-inline-end: 14px;\n  top: 20px;\n  transform: translateY(-50%);\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748B;\n  pointer-events: none;\n  line-height: 1;\n}\n\n.pkg-form textarea.ant-input {\n  height: auto !important;\n  min-height: 112px !important;\n  padding: 14px !important;\n  line-height: 1.6 !important;\n  resize: none;\n  font-weight: 400 !important;\n}\n\n.pkg-form .ant-picker {\n  width: 100%;\n  padding: 0 14px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.pkg-form .ant-picker-input > input {\n  font-size: 14px !important;\n}\n\n.pkg-form input.ant-input::placeholder,\n.pkg-form textarea.ant-input::placeholder,\n.pkg-form .ant-picker-input > input::placeholder,\n.pkg-form .ant-input-number-input::placeholder,\n.pkg-form .ant-select-selection-placeholder {\n  color: #94A3B8 !important;\n  opacity: 1 !important;\n  font-weight: 400 !important;\n}\n\n.pkg-form .ant-select-selection-item,\n.pkg-form .ant-select-selection-placeholder {\n  line-height: 38px !important;\n  font-size: 14px !important;\n}\n\n.pkg-form .ant-select-single .ant-select-selector {\n  display: flex !important;\n  align-items: center;\n  padding-inline: 14px !important;\n}\n\n.pkg-form .ant-select-arrow {\n  color: #94A3B8;\n}\n\n.pkg-form .ant-form-item-control-input-content > .ant-input:hover,\n.pkg-form textarea.ant-input:hover,\n.pkg-form .ant-picker:hover,\n.pkg-form .ant-input-number:hover,\n.pkg-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-color: #94A3B8 !important;\n}\n\n.pkg-form .ant-form-item-control-input-content > .ant-input:focus,\n.pkg-form textarea.ant-input:focus,\n.pkg-form .ant-picker-focused,\n.pkg-form .ant-input-number-focused,\n.pkg-form .ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.pkg-form .ant-input-number .ant-input:focus,\n.pkg-form .ant-picker-input > input:focus {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.pkg-form__segment.ant-radio-group {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px;\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  margin: 0;\n  padding: 4px;\n  border: 1px solid #CBD5E1;\n  border-radius: 12px;\n  background: #F8FAFC;\n}\n\n.pkg-form__segment .ant-radio-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  margin: 0;\n  padding: 0 8px;\n  border-radius: 8px;\n  color: #64748B;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.pkg-form__segment .ant-radio-wrapper-checked {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #0EA5E9;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.pkg-form__segment .ant-radio {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n}\n\n.pkg-form__segment .ant-radio + span {\n  padding: 0;\n}\n\n.pkg-form__segment-inner {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.pkg-form__segment-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: transparent;\n  flex-shrink: 0;\n}\n\n.pkg-form__segment-dot--on {\n  background: #0EA5E9;\n}\n\n.pkg-form__enable {\n  padding: 16px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: rgba(248, 250, 252, 0.7);\n  transition: background 0.12s ease;\n}\n\n.pkg-form__enable:hover {\n  background: #F8FAFC;\n}\n\n.pkg-form__enable .ant-checkbox-wrapper {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  margin: 0;\n}\n\n.pkg-form__enable .ant-checkbox {\n  align-self: flex-start;\n  margin-top: 2px;\n}\n\n.pkg-form__enable .ant-checkbox-inner {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  border-color: #CBD5E1;\n}\n\n.pkg-form__enable .ant-checkbox-checked .ant-checkbox-inner {\n  background: #0EA5E9;\n  border-color: #0EA5E9;\n}\n\n.pkg-form__enable-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.pkg-form__enable-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.pkg-form__enable-hint {\n  font-size: 12px;\n  font-weight: 400;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n@media (max-width: 1100px) {\n  .pkg-form__grid--4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .pkg-form__grid--2,\n  .pkg-form__grid--4 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
